import ally from 'ally.js/ally';
import * as helpers from '../helpers';

export default class OpenHeaderPopup {
    constructor() {
        this.options = {
            elements: [
                {
                    button: 'header-search__btn',
                    popup: 'search-popup',
                    otherElements: ['header-search__btn', 'login__btn-current', 'profile__btn-current', 'menu-toggle'],
                },
                {
                    button: 'login__btn-current',
                    popup: 'extranet__section',
                    otherElements: ['header-search__btn', 'login__btn-current', 'menu-toggle'],
                },
            ],
        };

        this.$keyHandler = null;
        this.profileOpen = {
            elem: null,
            button: null,
            popupBlock: null,
            init: false,
        };
        this.activeElements = null;
        this.init();
    }

    init() {
        this.options.elements.forEach((el) => {
            const btn = document.querySelector(`.${el.button}`);
            const popup = document.querySelector(`.${el.popup}`);
            this.changeTabindex('close', popup);

            if (btn) {
                btn.addEventListener('click', (e) => {
                    const activeBtn = e.target.tagName === 'BUTTON' ? e.target : helpers.findAncestorByTag(e.target, 'BUTTON');
                    this.eventOpen(el, btn, popup, activeBtn);
                });
            }
        });
    }

    eventOpen(el, btn, popup, target) {
        const searchInput = popup.querySelector('input');

        if (!this.profileOpen.init) {
            this.profileOpen = {
                elem: el,
                button: btn,
                popupBlock: popup,
            };

            this.openPopup();
            if (searchInput) {
                searchInput.focus();
            }
        } else {
            const { elem, button, popupBlock } = this.profileOpen;
            this.closePopup();
            if (target && target !== button) {
                this.eventOpen(el, btn, popup);
            }
        }
    }

    changeTabindex(type, block) {
        if (block) {
            this.activeElements = ally.query.focusable({ context: block });

            if (type === 'open') {
                this.activeElements.forEach((el) => {
                    el.setAttribute('tabindex', 0);
                });
            } else {
                this.activeElements.forEach((el) => {
                    el.setAttribute('tabindex', -1);
                });
            }
        }
    }

    replaceButtonText(button) {
        const altText = button.getAttribute('data-alt-text');
        const defaultText = button.lastElementChild.innerText;

        if (altText) {
            button.lastElementChild.innerText = altText;
            button.setAttribute('data-alt-text', defaultText);
        }
    }

    openPopup() {
        const menu = document.querySelector('.js-mnv');

        if (helpers.hasClass(menu, '-is-open')) {
            const evt = document.createEvent('Event');
            evt.initEvent('click', false, true);
            document.querySelector('.js-mnv-toggle').dispatchEvent(evt);
        }

        const { elem, button, popupBlock } = this.profileOpen;
        helpers.addClass(document.body, '-overflow-hidden');
        helpers.addClass(button, '-is-open');
        helpers.addClass(popupBlock, '-is-open');

        this.changeTabindex('open', popupBlock);
        this.replaceButtonText(button);

        this.$keyHandler = ally.when.key({
            // context: popup,
            tab: (e) => {
                this.nextKeysHandler(e, popupBlock, this.getOtherElements(elem.otherElements));
            },
            'shift+tab': (e) => {
                this.prevKeysHandler(e, popupBlock, this.getOtherElements(elem.otherElements));
            },
            escape: (e) => {
                this.closePopup('esc');
            },
        });

        this.profileOpen.init = true;
    }

    closePopup(type) {
        const { elem, button, popupBlock } = this.profileOpen;
        helpers.removeClass(document.body, '-overflow-hidden');
        helpers.removeClass(button, '-is-open');
        helpers.removeClass(popupBlock, '-is-open');

        if (button) {
            this.replaceButtonText(button);
        }

        if (popupBlock) {
            this.changeTabindex('close', popupBlock);
        }

        if (button && type === 'esc') {
            button.focus();
        }

        if (this.$keyHandler) {
            this.$keyHandler.disengage();
        }

        this.profileOpen = {
            elem: null,
            button: null,
            popupBlock: null,
            init: false,
        };
    }

    getOtherElements(array) {
        const newArray = [];
        array.forEach((elClass) => {
            const btn = document.querySelector(`.${elClass}`);
            if (btn) {
                newArray.push(btn);
            }
        });

        return newArray;
    }

    nextKeysHandler(event, content, otherElements) {
        event.preventDefault();

        const nextElement = helpers.getNextFocusableElement(event.target, content, otherElements);

        if (nextElement) {
            ally.element.focus(nextElement);
        }
    }

    prevKeysHandler(event, content, otherElements) {
        event.preventDefault();
        const prevElement = helpers.getPrevFocusableElement(event.target, content, otherElements);

        if (prevElement) {
            ally.element.focus(prevElement);
        }
    }
}
